var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"calc(100vh - 71px)"}},[_c('div',{staticClass:"row mx-0 border-bottom"},[_c('tabs',{attrs:{"tabs":_vm.tabs}})],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }